interface MaybeUserRecord {
  verified?: boolean;
  isAdmin?: boolean;
  isModerator?: boolean;
  role?: string;
}

const hasStaffPrivileges = (user?: MaybeUserRecord | null): boolean => {
  if (!user) return false;
  const role = String(user.role || '').toLowerCase();
  return !!user.isAdmin || !!user.isModerator || role === 'admin' || role === 'super_admin' || role === 'moderator';
};

export const deriveVerifiedStatus = (user?: MaybeUserRecord | null): boolean => {
  if (!user) return false;
  return hasStaffPrivileges(user) || !!user.verified;
};

export const isUnlimitedAdsEligible = (user?: MaybeUserRecord | null): boolean => {
  return hasStaffPrivileges(user);
};

export const resolveVerifiedFlag = (explicit?: boolean, fallback?: boolean): boolean => {
  if (typeof explicit === 'boolean') return explicit;
  if (typeof fallback === 'boolean') return fallback;
  return false;
};
